const $$splitComponentImporter = () => import('/app/src/routes/grupne-terapije/payment-result.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { legacyEnrollmentSearch } from "@/lib/payment-return-url";

// Legacy Monri return URL (`?status=..&enrollment=..`), kept for payment forms
// opened before the path-based URLs. Monri glues its own params onto ours with
// a second `?` and sends an `enrollment` param of its own (3-D Secure);
// legacyEnrollmentSearch cuts and dedupes them.
export const Route = createFileRoute("/grupne-terapije/payment-result")({
  validateSearch: (search: Record<string, unknown>) => legacyEnrollmentSearch(search),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});